module.exports = __webpack_public_path__ + "static/media/raise_u.7b7afe42.png";